// This validates dates of the format DD/MM/YYYY, the format we display in date pickers
const SIMPLE_DATE_REGEX = /\d{2}\/\d{2}\/\d{4}/
export const validateSimpleDate = (value: string) => SIMPLE_DATE_REGEX.test(value) || "Please enter a valid date"
